export enum RefundReasonEnum {
    DUPLICATE = 'duplicate',
    FRAUDULENT = 'fraudulent',
    CUSTOMER_REQUEST = 'customer-request',
    OTHER = 'other'
}

